import { RootState } from '../types/store'

export const getOrderState = (store: RootState) => store.orderState
